import utils from "@/utilities/Utils";

export class PasswordChangeRequest {
    userID: string = utils.emptyGuidValue;
    existingPassword: string = "";
    newPassword: string = "";
    repeatPassword: string = "";
}